import React, { FC, useContext, useEffect, useState } from "react";
import CommonLayout from "./CommonLayout";
import AppContext from 'AppContext';
import { Helmet } from "react-helmet";
import { useTranslation } from 'react-i18next';
import { InformationCookiesMarketing } from 'shared/InformationCookiesMarketing/InformationCookiesMarketing';
import heymondoImg from "images/banniereHeymondo.png";

export interface ReservationAssuranceProps {
  className?: string;
}

const ReservationAssurance: FC<ReservationAssuranceProps> = ({ className = "" }) => {
  const { t } = useTranslation();

  const { setVoyageInfo, setAfficheMenuMobile } = useContext(AppContext);

  const [cookiePartenaires, setCookiePartenaires] = useState<boolean>(true);

  // Fonction pour obtenir la valeur d'un cookie
  const getCookie = (name: string) => {
    const cookieValue = document.cookie
      .split('; ')
      .find(row => row.startsWith(name))
      ?.split('=')[1];
    return cookieValue || '';
  };

  useEffect(() => {
    setVoyageInfo(null);
    setAfficheMenuMobile(false);
    const cookieValue = getCookie("tripkygoPartenaires");

    if (cookieValue && cookieValue === 'O') {

      setCookiePartenaires(true);
    }
    else
    {
      setCookiePartenaires(false);
    }
    
  }, []);

  const handleInfoClick = () => {
    alert(
      t('infoHeymondo')
    );
  };

  return (
    <div className={`nc-ReservationAssurance ${className}`} data-nc-id="ReservationAssurance">
      <Helmet>
        <title>{t('reservation')}</title>
      </Helmet>
      <CommonLayout>
      <div className="text-center">
           <h1 className="font-medium leading-6 text-gray-900 dark:text-neutral-300 mb-6">
              {t('souscrireAssurance')} <a href='https://heymondo.fr/?utm_medium=Afiliado&utm_source=TRIPKYGO&utm_campaign=PRINCIPAL&cod_descuento=TRIPKYGO&ag_campaign=ENTRÉE&agencia=3hQVt0r9iXdLzPmk8ifQnh987F9EtoECjFcT7HZz' rel="noreferrer" target="_blank"><u>Heymondo</u></a>
                  <sup>
                    <button type="button" onClick={handleInfoClick}>
                      <i className="las la-info"></i>
                    </button>
                  </sup>
                </h1>
                           
                {cookiePartenaires ? (
           <img
           loading="lazy"
           src={heymondoImg}
           title="Assurance Heymondo"
           width="100%"
           height="800px"
           className="curseurPointeur"
             onClick={() => window.open("https://heymondo.fr/?utm_medium=Afiliado&utm_source=TRIPKYGO&utm_campaign=PRINCIPAL&cod_descuento=TRIPKYGO&ag_campaign=ENTRÉE&agencia=3hQVt0r9iXdLzPmk8ifQnh987F9EtoECjFcT7HZz", "_blank")}
         ></img>
        
          ) : (
           <InformationCookiesMarketing/>
          
          
          )}
            
        
        </div>
      </CommonLayout>
    </div>
  );
};

export default ReservationAssurance;
